import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Mode } from '../../../types';
import { ModeContext } from '../../../context';
import { getAggregatedSummaryServices, getCheckinAggregatedSummaryServices } from '../model/selectors';
export function useAggregatedSummaryServices() {
    let aggregatedSummaryServices;
    const mode = useContext(ModeContext);
    if (mode === Mode.Checkin) {
        aggregatedSummaryServices = useSelector(getCheckinAggregatedSummaryServices);
    }
    else {
        aggregatedSummaryServices = useSelector(getAggregatedSummaryServices);
    }
    return aggregatedSummaryServices;
}
